/*
 * File: c:\Users\j.mazat\Desktop\Autofi\autofi_backoffice\src\Content\CollapseDiv\CollapseDiv.tsx
 * Project: c:\Users\j.mazat\Desktop\Autofi\autofi_backoffice
 * Created Date: Tuesday April 2nd 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday April 2nd 2024 10:42:03 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { useCallback, useState } from "react";
import { IoIosArrowDropdownCircle, IoIosArrowDropupCircle } from "react-icons/io";
import Styles from "Content/CollapseDiv/CollapseDiv.module.css";
import { Collapse } from "react-collapse";

type CollapsDivProps = {
    title: string,
    children: JSX.Element,
}

export default function CollapseDiv(props: CollapsDivProps) {
    const [isCollapse, setIsCollapse] = useState(true);

    const onClick = useCallback(
        () => setIsCollapse(!isCollapse), [isCollapse]
    );

    return(
        <>
            <button className={`${Styles.collapseCarDataBtn}`} onClick={onClick}>
                <span className={`${Styles.bold}`}>
                    {props.title}
                </span>
                <div>
                    {
                        !isCollapse ?
                            <IoIosArrowDropdownCircle/>
                            :<IoIosArrowDropupCircle />
                    }
                </div>
            </button>
            <Collapse isOpened={isCollapse}>
                {props.children}
            </Collapse>
        </>
    );
};
